import React, { useEffect, useState } from 'react'
import { makePutRequest } from 'utils/api'

function SelectCategory({ row, updateLoading, categories }) {
  // console.log(categories)
  const [currentCat, setCurrentCat] = useState('')
  useEffect(() => {
    setCurrentCat(row.SousCategorie.length === 0 ? '' : row.SousCategorie[0].id)
  }, [])
  useEffect(() => {
    setCurrentCat(row.SousCategorie.length === 0 ? '' : row.SousCategorie[0].id)
  }, [categories])
  const onChangeCategory = async (e, element) => {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }

    let currentCategory = e.target.value
    let data = JSON.parse(JSON.stringify(element))
    data.Catégorie = currentCategory

    setCurrentCat(currentCategory)
    const res = await makePutRequest('/api/Finance/update/Operationsfi/', data, {}, true)

    updateLoading()
  }
  return (
    <select
      key={row.id}
      className="form-control form-control-sm"
      onChange={(e) => onChangeCategory(e, row)}
      value={currentCat}
    >
      <option value="">&nbsp;</option>
      {categories &&
        categories.map((row2, index2) => (
          <React.Fragment key={row2.id}>
            {parseFloat(row.Montant) < 0 && row2.Mouvement === 'Dépense' && (
              <option key={`op1-${row2.id}`} value={row2.id}>
                {row2.SousCategorie}
              </option>
            )}
            {parseFloat(row.Montant) > 0 && row2.Mouvement === 'Revenu' && (
              <option key={`op2-${row2.id}`} value={row2.id}>
                {row2.SousCategorie}
              </option>
            )}
          </React.Fragment>
        ))}
    </select>
  )
}

export default SelectCategory
